import APIServiceLookUp from './serviceAPI';
import { API_URL } from './models/AppConstent';

export default class ServiceProfiles {
    lookupService = new APIServiceLookUp();

    async updatePartner(body, token) {
        var serviceType = "POST";
        var url = `${API_URL}partner/updatePartnerStaff`;
        var apiService = this.lookupService.getAPIService(serviceType);
        return await apiService.doCall(url, body, token);
    }

    async getPartnerStaffById(body, token) {
        var serviceType = "POST";
        var url = `${API_URL}partnerstaff/getStaffById`;
        var apiService = this.lookupService.getAPIService(serviceType);
        return await apiService.doCall(url, body, token);
    }
}